import { MenuOptionGroup } from '@chakra-ui/react';

import { TriangleExclamation } from '@enterprise/ui';

import type { MailingListsMenuProps } from './types/mailing-lists-menu.props';

import MailingTypeMenu from './mailing-type-menu';
import RadioMenuItem from './radio-menu-item';

const MailingListsMenu = ({ isActive }: MailingListsMenuProps) => {
  return (
    <MailingTypeMenu
      bottomMenuItemsSlot={({ pathSegment, selectedMenu }) => {
        return (
          <MenuOptionGroup>
            <RadioMenuItem
              icon={
                <TriangleExclamation
                  size="lg"
                  widthAuto
                />
              }
              isSelected={selectedMenu === 'missing-lists'}
              replace
              state={{ selectedMenu: 'missing-lists' }}
              to={`/datastream/${pathSegment}/missing-lists`}>
              Missing Lists
            </RadioMenuItem>
          </MenuOptionGroup>
        );
      }}
      isActive={isActive}
      label="List Manager"
      pathSegment="listmanager"
    />
  );
};

export default MailingListsMenu;
